function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8 15.1899C12.0869 15.1899 15.4707 11.8062 15.4707 7.71924C15.4707 3.63965 12.0796 0.248535 7.99268 0.248535C3.91309 0.248535 0.529297 3.63965 0.529297 7.71924C0.529297 11.8062 3.92041 15.1899 8 15.1899ZM7.29688 10.9785C7.09912 10.9785 6.94531 10.8906 6.75488 10.7148L3.53955 7.69727C3.38574 7.55078 3.33447 7.4043 3.33447 7.25781C3.33447 7.11865 3.38574 6.97217 3.53955 6.82568L6.75488 3.83008C6.96729 3.625 7.0918 3.54443 7.28955 3.54443C7.5752 3.54443 7.78027 3.76416 7.78027 4.03516V5.57324H7.89746C10.8052 5.57324 12.0869 7.43359 12.0869 10.4438C12.0869 10.7954 11.8745 10.9785 11.6621 10.9785C11.4863 10.9785 11.3032 10.9346 11.1641 10.6782C10.4609 9.35254 9.46484 8.94971 7.89746 8.94971H7.78027V10.5098C7.78027 10.7734 7.5752 10.9785 7.29688 10.9785Z",
  fill: "#878793"
});

function SvgIconReplyFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReplyFilled);
export default __webpack_public_path__ + "static/media/icon-reply-filled.78faab47.svg";
export { ForwardRef as ReactComponent };